/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class ProductProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Get the Product by ID
	 * @param {String|Number} pProductID - The Product ID to search for
	 * @return {Promise<Array<any>>}
	 * @async
	 */
	getProductByID(pProductID)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pProductID)
			{
				this.pict.log.error('No Product ID provided.');
				return reject(new Error('No Product ID provided.'));
			}

			this.pict.HeadlightRestClient.getJSON(`Product/${pProductID}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting Product: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}
}

module.exports = ProductProvider;
module.exports.default_configuration = {};
